/**
 * This file is part of "Zona franca"
 * Copyright (c) 2022
 * Zona franca
 * All rights reserved
 *
 * @author Turiano Romero <https://bitbucket.org/rome9603/ | tromero@technisupport.com>
 * @version 2.0
 */

import { securityTypes } from "redux/types";

const initialState = {
  dataVetaTruck: [],
  dataVetaPerson: [],
  dataVetaDriver: []
};

export const securityReducer = (state = initialState, action) => {
  switch (action.type) {
    case securityTypes.setDataTruck:
      return {
        ...state,
        dataVetaTruck: action.payload
      };

    case securityTypes.setDataVetaPerson:
      return {
        ...state,
        dataVetaPerson: action.payload
      };

    case securityTypes.setDataVetaDriver:
      return {
        ...state,
        dataVetaDriver: action.payload
      };

    default:
      return state;
  }
};
